module.exports = __webpack_public_path__ + "img/manulife-banner-logo-fr.a0351c92.svg";